import React from 'react'
import '../../Work-css/Payment_gatway.css';

function Payment_gateway() {
  return (
    <div className='PG'>
        <div className='PG_web'>
            <p className='fill_In'>Payment Gateway</p>
            <p className='text_PG'>Hostel/Account Booking fee: Ksh 300</p>
            <p className='text_PG'>Guidance and Counseling fee: Ksh 300</p>
            <p className='text_PG'>(Please inquire Guidance and Counselling fee or the Hostel/Account Booking fee)</p>
            <p className='text_PG'>Annual data storage/Service fee Booking fee: Ksh 200</p>
            <p className='text_PG'>PayBill: 480 587</p>
            <p className='text_PG'>Hostel fee/accomodation fee account number: 054 1243</p>
            
        </div>
    </div>
  )
}

export default Payment_gateway